import React from 'react';

type VideoCodec = 'av1' | 'h265' | 'h264' | (string & {});

export interface VideoSourceType {
  url: string;
  codecName: VideoCodec;
}

export interface VideoProps
  extends React.VideoHTMLAttributes<HTMLVideoElement>,
    React.RefAttributes<HTMLVideoElement> {
  sources: VideoSourceType[];
}

export const Video = ({sources, children, ref, ...rest}: VideoProps) => {
  return (
    <video ref={ref} {...rest}>
      {sources.map(({url, codecName}) => {
        if (!codecName) return null;
        if (!CODEC_MIME_TYPES[codecName]) {
          // eslint-disable-next-line no-console
          console.error(
            `Unsupported codec "${codecName}". Please provide a valid codec name.`,
          );
          return null;
        }

        return (
          <source
            key={codecName}
            src={url}
            type={CODEC_MIME_TYPES[codecName]}
          />
        );
      })}
      {children}
    </video>
  );
};

const CODEC_MIME_TYPES: Record<VideoCodec, string> = {
  av1: 'video/mp4; codecs="av01.0.05M.08"',
  h265: 'video/mp4; codecs="hvc1.1.6.L93.B0"',
  h264: 'video/mp4; codecs="avc1.42E01E"',
};
